"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProjectInformationDirective = /** @class */ (function () {
    function ProjectInformationDirective() {
        return {
            restrict: 'EA',
            scope: true,
            bindToController: {
                projectName: '=',
                customerName: '='
            },
            templateUrl: '/Partner/TaskComponents/ProjectInformation',
            controllerAs: 'projectInformation',
            controller: function () {
            }
        };
    }
    ProjectInformationDirective.create = function () {
        return new ProjectInformationDirective();
    };
    return ProjectInformationDirective;
}());
exports.ProjectInformationDirective = ProjectInformationDirective;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdEluZm9ybWF0aW9uLmRpcmVjdGl2ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInByb2plY3RJbmZvcm1hdGlvbi5kaXJlY3RpdmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQTtJQUNJO1FBQ0ksT0FBTztZQUNILFFBQVEsRUFBRSxJQUFJO1lBQ2QsS0FBSyxFQUFFLElBQUk7WUFDWCxnQkFBZ0IsRUFBRTtnQkFDZCxXQUFXLEVBQUUsR0FBRztnQkFDaEIsWUFBWSxFQUFFLEdBQUc7YUFDcEI7WUFDRCxXQUFXLEVBQUUsNENBQTRDO1lBQ3pELFlBQVksRUFBRSxvQkFBb0I7WUFDbEMsVUFBVSxFQUFFO1lBQ1osQ0FBQztTQUNKLENBQUE7SUFDTCxDQUFDO0lBQ00sa0NBQU0sR0FBYjtRQUNJLE9BQU8sSUFBSSwyQkFBMkIsRUFBRSxDQUFDO0lBQzdDLENBQUM7SUFFTCxrQ0FBQztBQUFELENBQUMsQUFuQkQsSUFtQkM7QUFuQlksa0VBQTJCIn0=